import { render, staticRenderFns } from "./GetLogs.vue?vue&type=template&id=fb478188&"
import script from "./GetLogs.vue?vue&type=script&lang=js&"
export * from "./GetLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports